import React from 'react';

import EmptyList from 'components/EmptyList';

interface Props {
  description: string;
}

const EmptyView = ({ description }: Props) => <EmptyList description={description} image="" transparent />;

export default EmptyView;
